import useAppToast from '@/hooks/useAppToast';
import type { ClinicUserListMeta, ClinicUserListParams } from '@/services/admin/clinicUsers';
import { getClinicUsers } from '@/services/admin/clinicUsers';
import { DEFAULT_FETCH_ERROR_MESSAGE, getApiErrorMessage } from '@/utils/apiError';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const DEFAULT_META: ClinicUserListMeta = {
  current_page: 1,
  last_page: 1,
  per_page: 20,
  total: 0,
};

/**
 * Query hook to fetch paginated clinic user list (admin portal).
 */
export const useClinicUserListQuery = (siteType: string, params: ClinicUserListParams) => {
  const toast = useAppToast();

  const { data, isLoading, isError, isPending, refetch, error } = useQuery({
    queryKey: [
      'admin',
      'clinic-users',
      'list',
      siteType,
      params.search_login_id,
      params.search_name,
      params.sort,
      params.page,
      params.site_types,
    ],
    queryFn: () => getClinicUsers(siteType, params),
    enabled: !!siteType,
    /** Override global staleTime: refetch on every 検索 click. */
    staleTime: 0,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  // const meta = useMemo(() => data?.meta ?? DEFAULT_META, [data?.meta]);

  return { data: data?.data, isLoading, isError, isPending, refetch, error, meta: data?.meta ?? DEFAULT_META };
};
